module.exports = __webpack_public_path__ + "src/img/down-red.de175db4.svg";